import React from "react";
import { images } from '../../../assets'

export default function ConnectStatus({ status, className }) {
    const APP_CONNECT_STATUS = {
        Normal: "Y",
        Failure: "N",
        Unlinked: false,
      };
  const checkStatus = (status) => {
    switch (status) {
      case APP_CONNECT_STATUS.Normal:
        return {
          img: images.dot_normal,
          className: "normal"
        };
      case APP_CONNECT_STATUS.Failure:
        return {
          img: images.dot_failure,
          className: "failure"
        };
      default:
        // return {
        //   img: images.dot_unlinked,
        //   className: "unlinked"
        // };
        return {
          img: '',
          className: ''
        };
    }
  };

  return (
    <div className={`connect-status flex align-middle gap-1 ${checkStatus(status).className}`}>
      <div className="flex items-center">
        <img src={checkStatus(status).img} />
      </div>
    </div>
  );
}
